<template>
    <div class="orientation">
        <template v-for="orientation in orientations">
            <form-checkbox
                :ref="'orientation-control-' + orientation.id"
                :key="orientation.id"
                :value="orientationIds.indexOf(orientation.id) !== -1"
                @input="onChange(orientation.id, $event)"
                :name="orientation.id"
                :label="orientation.title"
                class="checkbox--third"
            />
        </template>
    </div>
</template>

<script>
import FormCheckbox from 'domovio-core/src/components/Form/Input/FormCheckbox';

export default {
    name:       'OrientationContainer',
    components: {FormCheckbox},
    computed:   {
        orientations() {
            return this.$store.getters['projects/project/orientations'];
        },
        orientationIds() {
            return this.$store.getters['projects/project/units/unit/orientationIds']
        }
    },
    methods:    {
        onChange(orientationId, connected) {
            const refs = this.$refs;
            this.$store.dispatch('projects/project/units/unit/updateOrientation', {orientationId, connected})
                .then(() => {
                    const orientationRefKey = 'orientation-control-' + orientationId;
                    if (refs.hasOwnProperty(orientationRefKey)) {
                        refs[orientationRefKey][0].successHighlight();
                    }
                })
                .catch((message) => this.$dmv.notifyError(message))
        }
    }
}
</script>
